<div class="section-header">
    <!--    <app-info-icon-button-->
    <!--        [model]="{ title: 'Information',-->
    <!--                   messages: ['text is not defined yet'],-->
    <!--                   dialogHeight: 100}">-->
    <!--    </app-info-icon-button>-->
    <div class="title">
        Mitarbeiter
    </div>
</div>

<div>
    <bd-labeled-select-input label="KAM*" placeholder="Wird automatisch ausgewählt"
                             required
                             [forceFormValidationVisibility]="forceFormValidationVisibility"
                             [choices]="getContactChoices(model.project.brotherContacts.kam.kamContacts)"
                             [values]="getContactValues(model.project.brotherContacts.kam.kamContacts)"
                             name="kamContact" [(ngModel)]="model.project.brotherContacts.kam.selectedKamContact"
                             #kamNgModel="ngModel"
                             (ngModelChange)="updateVlContact()">>
    </bd-labeled-select-input>
    <bd-input-error-viewer [ngModelRef]="kamNgModel">
    </bd-input-error-viewer>

    <!--    <bd-labeled-select-input label="VL" placeholder="Wird automatisch ausgewählt"-->
    <!--                             disabled-->
    <!--                             [choices]="getContactChoices(model.project.brotherContacts.vl.vlContacts)"-->
    <!--                             [values]="getContactValues(model.project.brotherContacts.vl.vlContacts)"-->
    <!--                             name="vlContact" [(ngModel)]="model.project.brotherContacts.vl.selectedVlContact"-->
    <!--                             -->
    <!--    </bd-labeled-select-input>-->


    <bd-labeled-input label="VL"
                      disabled
                      name="vlContact" [ngModel]="getVlContact()">
    </bd-labeled-input>

    <bd-labeled-select-input label="Innendienst*" placeholder="Bitte auswählen"
                             required
                             [forceFormValidationVisibility]="forceFormValidationVisibility"
                             [choices]="getContactChoices(model.project.brotherContacts.innendienst.innendienstContacts)"
                             [values]="getContactValues(model.project.brotherContacts.innendienst.innendienstContacts)"
                             name="innendienstContact"
                             [(ngModel)]="model.project.brotherContacts.innendienst.selectedInnendienstContact"
                             #innendienstContactNgModel="ngModel">
    </bd-labeled-select-input>
    <bd-input-error-viewer [ngModelRef]="innendienstContactNgModel">
    </bd-input-error-viewer>

    <bd-labeled-input label="Brother-GL*" placeholder="Brother-GL"
                      disabled
                      required
                      [forceFormValidationVisibility]="forceFormValidationVisibility"
                      name="brotherGL" [(ngModel)]="model.project.brotherContacts.brotherGlContact">
    </bd-labeled-input>


    <bd-labeled-select-input label="Status" placeholder="Bitte auswählen"
                             [values]="getStatusValues()"
                             [choices]="getStatusChoices()"
                             name="status" [(ngModel)]="model.project.status"
                             (ngModelChange)="onStatusChanged()"
                             [disabled]="isStatusSelectDisabled()">
    </bd-labeled-select-input>


</div>



